import { toAviasalesCode } from "@/lib/airports";

const MONTHS = ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"];

/** „13 gru" z daty YYYY-MM-DD. */
export function formatDealDate(iso?: string): string | null {
  const m = iso?.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]}`;
}

/**
 * Parametr `flightSearch` wyszukiwarki Aviasales (np. KTW1512STN1 =
 * KTW → STN, 15.12, 1 dorosły) — otwiera wyniki dla konkretnej daty lotu,
 * na którą obowiązuje cena z feedu. `null` gdy brak daty lub kod nieobsługiwany.
 */
export function dealFlightSearch(from: string, to: string, iso?: string): string | null {
  const m = iso?.match(/^\d{4}-(\d{2})-(\d{2})$/);
  const o = toAviasalesCode(from);
  const d = toAviasalesCode(to);
  if (!m || !o || !d) return null;
  return `${o}${m[2]}${m[1]}${d}1`;
}
